import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || window.API_BASE_URL || 'http://localhost:3000',
});

// Attach JWT token to all requests
api.interceptors.request.use(
  (config) => {
    // Don't attach token for login
    if (config.url && config.url.includes('/auth/login')) return config;
    const token = localStorage.getItem('token');
    if (token) {
      console.log(`Attaching JWT to request: ${config.url}`);
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn(`No JWT token found for request: ${config.url}`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle JWT expiration and errors globally
api.interceptors.response.use(
  response => response,
  error => {
    // Standardize error message extraction
    let errorMessage = 'An unexpected error occurred';

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const status = error.response.status;
      const url = error.config?.url || 'unknown';
      const contentType = error.response.headers?.['content-type'] || '';
      
      // Try to extract error from JSON response
      let serverError = null;
      if (contentType.includes('application/json') && error.response.data) {
        serverError = error.response.data?.error || error.response.data?.message;
      }
      
      if (serverError) {
        errorMessage = `${status} ${error.response.statusText}: ${serverError} (${url})`;
      } else {
        // Non-JSON response (HTML error page, etc.)
        const snippet = typeof error.response.data === 'string' 
          ? error.response.data.slice(0, 200) 
          : 'non-JSON response';
        errorMessage = `${status} ${error.response.statusText}: ${snippet} (${url})`;
      }

      // Special handling for 401 Unauthorized (e.g. JWT expired)
      if (status === 401) {
        console.warn('Unauthorized (401). Clearing session and redirecting.');
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        // Redirect to login with a reason parameter
        // Only redirect if we're not already on the login page
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login?reason=expired';
        }
      }
    } else if (error.request) {
      // The request was made but no response was received
      errorMessage = `Network error: No response from server (${error.config?.url || 'unknown URL'})`;
    } else {
      // Something happened in setting up the request that triggered an Error
      errorMessage = `Request setup error: ${error.message}`;
    }

    return Promise.reject(new Error(errorMessage));
  }
);

export default api; 